import React from 'react';
import Header from './Header';
import Footer from './Footer';

const CookiesPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header />
            <main className="grow max-w-4xl mx-auto px-4 py-12">
                <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
                    <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de Cookies</h1>

                    <div className="prose prose-purple max-w-none text-gray-600">
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Qu'est-ce qu'un cookie ?</h2>
                            <p>
                                Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette, smartphone) lors de la visite d'un site web. Il permet au site de mémoriser vos actions et préférences pendant une certaine période.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Comment utilisons-nous les cookies ?</h2>
                            <p>
                                Nous utilisons des cookies pour :
                            </p>
                            <ul className="list-disc pl-5 mt-2 space-y-1">
                                <li>Assurer le bon fonctionnement du site (cookies essentiels)</li>
                                <li>Mémoriser vos préférences (langue, connexion)</li>
                                <li>Analyser l'utilisation du site pour l'améliorer</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Gestion des cookies</h2>
                            <p>
                                Vous pouvez à tout moment contrôler et/ou supprimer les cookies selon vos souhaits. Pour en savoir plus, consultez aboutcookies.org. Vous pouvez supprimer tous les cookies déjà présents sur votre ordinateur et paramétrer la plupart des navigateurs pour qu'ils les bloquent.
                            </p>
                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default CookiesPage;
